enum AppointmentExclusionReasonEnum {
  CANT_ATTEND_ON_SCHEDULED_TIME = 'cant_attend_on_scheduled_time',
  DUPLICATION_ERROR = 'duplication_error',
  PATIENT_ATTENDED_ALREADY = 'patient_attended_already',
  PATIENT_UNAVAILABLE_ON_SCHEDULED_TIME = 'patient_unavailable_on_scheduled_time',
  OTHERS = 'others',
}

export default AppointmentExclusionReasonEnum;
